(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["on9-diy-drawer"] && !Shopify.designMode) return;
  try {
    var roots = document.querySelectorAll('.on9-diy');

  roots.forEach(function (root) {
    if (root.dataset.on9Bound === '1') return;
    root.dataset.on9Bound = '1';

    var openBtn = root.querySelector('.on9-diy__open');
    var drawer = root.querySelector('.on9-diy__drawer');
    var panel = root.querySelector('.on9-diy__panel');
    var frame = root.querySelector('.on9-diy__frame');
    var backdrop = root.querySelector('.on9-diy__backdrop');
    if (!openBtn || !drawer || !panel || !frame || !backdrop) return;

    var origin = (root.dataset.embedOrigin || 'https://petkuso-ai.vercel.app').replace(/\/$/, '');
    var themeId = root.dataset.themeId || 'tpl_nope_face';
    var handle = root.dataset.productHandle || '';
    var baseImage = root.dataset.baseImage || '';
    var graphicHint = root.dataset.graphic || '';
    var graphicOption = parseInt(root.dataset.graphicOption || '0', 10);
    if (!graphicOption || graphicOption < 1 || graphicOption > 3) graphicOption = 0;
    var selectedVariantId = String(root.dataset.selectedVariant || '');
    var topupVariantId = root.dataset.topupVariantId || '68297349497083';
    var sizeChart = root.dataset.sizeChart || '';
    var colours = parseJson(root.dataset.colours, []);
    var sizes = parseJson(root.dataset.sizes, []);
    var variants = parseJson(root.dataset.variants, []);
    var blankMap = parseBlankMap(root.dataset.blankImages || '');

    function allowedOrigin() {
      try {
        return new URL(origin).origin;
      } catch (err) {
        return '';
      }
    }

    function themeForGraphic(text) {
      var value = normText(text);
      if (value.indexOf('DJ CAT') !== -1) return 'tpl_dj_cat';
      if (value.indexOf('NOPE') !== -1) return 'tpl_nope_face';
      if (value.indexOf('COLA(20-26CM') === 0) return 'tpl_cola_popcorn_cola';
      if (value.indexOf('POPCORN(20-26CM') === 0) return 'tpl_cola_popcorn_popcorn';
      return '';
    }

    function graphicOf(variant) {
      if (!variant || !graphicOption) return '';
      return variant['option' + graphicOption] || '';
    }

    function activeGraphicText() {
      var selected = null;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === selectedVariantId) {
          selected = variants[i];
          break;
        }
      }
      var fromVariant = graphicOf(selected);
      if (fromVariant) return fromVariant;
      return graphicHint;
    }

    function activeTheme() {
      var mapped = themeForGraphic(activeGraphicText());
      if (mapped) return mapped;
      if (String(handle).toLowerCase() === '210g-unisex-tcola-popcorn') return 'tpl_cola_popcorn_cola';
      return themeId;
    }

    var DIY_UID_KEY = 'petkuso_diy_uid_v1';
    var frameUid = '';

    function validDiyUid(value) {
      var text = String(value || '');
      return /^[A-Za-z0-9_-]{8,80}$/.test(text) ? text : '';
    }

    function mintDiyUid() {
      var bytes = new Uint8Array(16);
      if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
      else {
        var i;
        for (i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
      }
      var out = '';
      var j;
      for (j = 0; j < bytes.length; j++) out += ('0' + bytes[j].toString(16)).slice(-2);
      return out;
    }

    function writeParentUid(uid) {
      var clean = validDiyUid(uid);
      if (!clean) return '';
      try {
        window.localStorage.setItem(DIY_UID_KEY, clean);
      } catch (err) {
        /* private mode */
      }
      return clean;
    }

    function parentDiyUid() {
      if (frameUid) return frameUid;
      try {
        var existing = validDiyUid(window.localStorage.getItem(DIY_UID_KEY));
        if (existing) {
          frameUid = existing;
          return frameUid;
        }
      } catch (err) {
        /* private mode */
      }
      frameUid = writeParentUid(mintDiyUid());
      return frameUid;
    }

    function embedUrl() {
      try {
        var url = new URL('/embed', origin);
        if (handle) url.searchParams.set('handle', handle);
        var theme = activeTheme();
        if (theme) url.searchParams.set('theme', theme);
        if (baseImage) url.searchParams.set('base', baseImage);
        var graphicText = activeGraphicText();
        if (graphicText) url.searchParams.set('graphic', graphicText);
        var uid = parentDiyUid();
        if (uid) url.searchParams.set('uid', uid);
        return url.toString();
      } catch (err) {
        return '';
      }
    }

    function mountDrawer() {
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    }

    function parseJson(raw, fallback) {
      try {
        var parsed = JSON.parse(raw || '');
        return Array.isArray(parsed) ? parsed : fallback;
      } catch (err) {
        return fallback;
      }
    }

    function parseBlankMap(raw) {
      var map = {};
      String(raw || '').split('|').forEach(function (pair) {
        var cut = pair.indexOf('=');
        if (cut < 1) return;
        var label = pair.slice(0, cut).replace(/\s+/g, ' ').trim().toUpperCase();
        var url = httpUrl(pair.slice(cut + 1).trim());
        if (label && url) map[label] = url;
      });
      return map;
    }

    function sendProduct() {
      if (!frame.contentWindow) return;
      var target = allowedOrigin() || '*';
      frame.contentWindow.postMessage({
        source: 'on9-diy',
        type: 'product',
        colours: colours,
        sizes: sizes,
        sizeChart: sizeChart,
        blanks: blankMap
      }, target);
    }

    function loadFrame() {
      mountDrawer();
      var src = embedUrl();
      if (!src) return;
      if (frame.getAttribute('src') === src) return;
      frame.setAttribute('src', src);
    }

    function openDrawer() {
      loadFrame();
      if (!frame.getAttribute('src')) return;
      drawer.hidden = false;
      document.documentElement.classList.add('on9-diy-lock');
      openBtn.setAttribute('aria-expanded', 'true');
      panel.focus();
    }

    function closeDrawer() {
      drawer.hidden = true;
      document.documentElement.classList.remove('on9-diy-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    frame.addEventListener('load', sendProduct);
    openBtn.addEventListener('click', openDrawer);
    openBtn.addEventListener('mouseenter', loadFrame);
    openBtn.addEventListener('touchstart', loadFrame, { passive: true });
    backdrop.addEventListener('click', closeDrawer);

    function schedulePreload() {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(loadFrame, { timeout: 2000 });
        return;
      }
      window.setTimeout(loadFrame, 2000);
    }

    if (document.readyState === 'complete') schedulePreload();
    else window.addEventListener('load', schedulePreload);

    function formVariantId() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return '';
      var input = form.querySelector('[name="id"]');
      return input && input.value ? String(input.value) : '';
    }

    function syncVariant(id) {
      if (id) selectedVariantId = String(id);
      loadFrame();
    }

    document.addEventListener('change', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      if (!node.closest('form[action*="/cart/add"], product-form, .product-form')) return;
      syncVariant(formVariantId());
    });

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail;
      if (variant && variant.id) syncVariant(variant.id);
      else syncVariant(formVariantId());
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    var SIZE_TOKENS = ['XXXXL', 'XXXL', 'XXL', 'XL', 'S', 'M', 'L'];

    function normText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().toUpperCase();
    }

    function sizeToken(value) {
      var text = normText(value);
      var i;
      for (i = 0; i < SIZE_TOKENS.length; i++) {
        var token = SIZE_TOKENS[i];
        if (text === token || text.indexOf(token + ' ') === 0 || text.indexOf(token + '(') === 0) {
          return token;
        }
      }
      return '';
    }

    function variantOptions(variant) {
      var values = [];
      if (variant.option1) values.push(variant.option1);
      if (variant.option2) values.push(variant.option2);
      if (variant.option3) values.push(variant.option3);
      return values;
    }

    function mentionsNope(variant) {
      return variantBlob(variant).indexOf('NOPE') !== -1;
    }

    function variantBlob(variant) {
      var blob = normText(variant.title);
      var values = variantOptions(variant);
      var j;
      for (j = 0; j < values.length; j++) blob += ' ' + normText(values[j]);
      return blob;
    }

    function pickVariant(variants, colour, size) {
      var wantColour = normText(colour);
      var wantSize = sizeToken(size);
      var wantGraphic = normText(activeGraphicText());
      if (!wantColour || !wantSize) return null;
      var found = [];
      var i;
      for (i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var values = variantOptions(variant);
        var colourOk = false;
        var sizeOk = false;
        var j;
        for (j = 0; j < values.length; j++) {
          if (normText(values[j]) === wantColour) colourOk = true;
          if (sizeToken(values[j]) === wantSize) sizeOk = true;
        }
        if (wantGraphic && variantBlob(variant).indexOf(wantGraphic) === -1) continue;
        if (colourOk && sizeOk) found.push({ variant: variant, index: i });
      }
      if (!found.length) return null;
      found.sort(function (a, b) {
        var aAvail = a.variant.available === false ? 0 : 1;
        var bAvail = b.variant.available === false ? 0 : 1;
        if (aAvail !== bAvail) return bAvail - aAvail;
        if (!wantGraphic) {
          var aNope = mentionsNope(a.variant) ? 1 : 0;
          var bNope = mentionsNope(b.variant) ? 1 : 0;
          if (aNope !== bNope) return bNope - aNope;
        }
        return a.index - b.index;
      });
      return found[0].variant;
    }

    function httpUrl(value) {
      try {
        var url = new URL(String(value || ''));
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
        return url.toString();
      } catch (err) {
        return '';
      }
    }

    function showToast(message) {
      var toast = root.querySelector('.on9-diy__toast');
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
    }

    function refreshThemeCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
          var count = cart && typeof cart.item_count === 'number' ? String(cart.item_count) : '';
          var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]');
          if (!count || !bubbles.length) return;
          bubbles.forEach(function (node) {
            node.textContent = count;
          });
        })
        .catch(function () {
          window.location.assign('/cart');
        });
    }

    function addTopup(data) {
      var variantId = String(topupVariantId || '').replace(/\D/g, '');
      var uid = String((data && data.uid) || '').trim();
      if (!variantId) {
        showToast('未設定加購次數。');
        return;
      }
      if (!uid || uid.length > 96) {
        showToast('搵唔到你嘅編號，請再試。');
        return;
      }
      var numericId = Number(variantId);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: numericId,
          quantity: 1,
          properties: {
            '_petkuso_uid': uid
          }
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      }).then(function () {
        window.location.assign('/checkout');
      }).catch(function () {
        showToast('加購次數未能加入購物車，請再試。');
      });
    }

    function addDiyToCart(data) {
      var imageUrl = httpUrl(data.imageUrl);
      var previewUrl = httpUrl(data.previewUrl);
      var mode = data.mode === '連T' || data.mode === '淨圖' ? data.mode : '';
      if (!imageUrl || !previewUrl || !mode) {
        showToast('設計網址唔完整，請再試。');
        return;
      }
      var variant = pickVariant(variants, data.colour, data.size);
      if (!variant || !variant.id) {
        showToast('搵唔到呢個顏色同尺碼。');
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          properties: {
            '_DIY圖': imageUrl,
            '預覽': previewUrl,
            '模式': mode
          }
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      }).then(function () {
        showToast('已加入購物車');
        closeDrawer();
        refreshThemeCart();
      }).catch(function () {
        showToast('加入購物車失敗，請再試。');
      });
    }

    window.addEventListener('message', function (event) {
      var data = event.data;
      if (!data || data.source !== 'on9-diy') return;
      if (frame.contentWindow && event.source !== frame.contentWindow) return;
      var allowed = allowedOrigin();
      if (allowed && event.origin !== allowed) return;
      if (data.type === 'close') closeDrawer();
      if (data.type === 'ready') sendProduct();
      if (data.type === 'diy-uid') writeParentUid(data.uid);
      if (data.type === 'add-to-cart') addDiyToCart(data);
      if (data.type === 'topup') addTopup(data);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
